import home from './home';
import promotion from './promotion';
import article from './article';
import review from './review';
import slot from './slot';
import casino from './casino';
import sport from './sport';
import lotto from './lotto';
import keno from './keno';
import crash from './crash';
import cards from './cards';
import demo from './demo';

const CONTENT = { home, promotion, article, review, slot, casino, sport, lotto, keno, crash, cards, demo };
export default CONTENT;
